import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import { connect } from 'react-redux';
import { CreateEventActions } from '../../actions';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {faCalendarAlt, faArrowLeft} from '@fortawesome/fontawesome-free-solid';
import { Input, Submit } from '../Form';

class CreateEventForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: "",
            coupon: "",
            error: {
                name: false,
                coupon: false
            }
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    validation() {
        const {eventType} = this.props;
        const {name, coupon} = this.state;
        const err = {
            name: (name.trim().length < 5),
            coupon: (eventType !== 'demo' && coupon.trim().length < 6)
        }

        this.setState({error: {...this.state.error, ...err}});

        return !err.name && !err.coupon;
    }

    handleChange(event) {
        var obj = {};
        obj[event.target.name] = event.target.value;
        this.setState(obj);
    }

    handleSubmit(event) {
        event.preventDefault();

        if(this.validation()) {
            const { dispatch, eventType } = this.props;
            const { coupon, name} = this.state;

            const data = {
                name: name
            }

            if(eventType === 'demo') data.demo = true;
            else data.coupon = coupon;

            dispatch(CreateEventActions.create(data));
        }
    }

    render() {
        const {eventType} = this.props;
        const isDemo = eventType === 'demo';
        const requestInProcess = false;

        return (
            <div>
                <div className="subTitle">
                    {/* <FontAwesomeIcon icon={faCalendarAlt} /> יצירת אירוע חדש */}
                </div>
                <form onSubmit={this.handleSubmit} noValidate>
                    <Input
                        name="name"
                        value={this.state.name}
                        placeholder="שם האירוע (לדוגמא: החתונה של גל וגלי בכתר יהוד)"
                        error={this.state.error.name}
                        errorText="שם האירוע חייב להיות עם לפחות 5 תווים"
                        onChange={this.handleChange}
                    />

                    <Input
                        className={`${isDemo ? 'hide' : ''}`}
                        name="coupon"
                        value={this.state.coupon}
                        placeholder="קוד קופון (לקבלת קוד  קופון התקשרו לגל- 072-3281388)"
                        onChange={this.handleChange}
                        label={false}
                        error={this.state.error.coupon}
                        errorText="חובה למלא קוד קופון (לקבלת קוד  קופון התקשרו לגל- 072-3281388)"
                    />

                    <Submit process={requestInProcess} icon="faPlusCircle" text={`${isDemo ? 'יצירת אירוע לדוגמא' : 'יצירת אירוע'}`}/>
                </form> 
                <Link to="/events/create?type=demo" className={`${isDemo ? 'hide' : ''} goToCreateDemoBtn`}>
                    ליצירת אירוע לדוגמא ללא קופון
                    &nbsp;<FontAwesomeIcon icon={faArrowLeft}/>
                </Link>
                <Link to="/events/create" className={`${!isDemo ? 'hide' : ''} goToCreateDemoBtn`}>
                    ליצירת אירוע רגיל
                    &nbsp;<FontAwesomeIcon icon={faArrowLeft}/>
                </Link>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        createEvent: state.createEventReducer
    }
}

const CreateEventFormWithRedux = connect(mapStateToProps)(CreateEventForm);

export {CreateEventFormWithRedux as CreateEventForm};


// WEBPACK FOOTER //
// ./src/components/CreateEventPage/CreateEventForm.jsx